import { Detail, List, Create } from "./views";

const Module = {
    name: "externalentities",
    defaultRoutePath: "/companies/externalentity",
    menuItemScope: "companies",
    menuItemName: "externalentities",
    routes: [],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        }
    ],

}

export default Module;
